import { render, staticRenderFns } from "./EducationalPeriodCards.vue?vue&type=template&id=98f74b20&"
import script from "./EducationalPeriodCards.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports